import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import {
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { getIncomeByTuitionData } from '../../../requests/api/dashboard';
import { DEFAULT_API_ERROR_MESSAGE } from '../../../utils/errors';
import { useYear } from '../../../hooks/useYear';
import Page from '../../../components/Layout/Page';
import IndicatorsTable from '../components/table';
import { IncomeByTuitionData } from '../types';
import useStyles from './styles';

const IncomeByTuition: React.FC = () => {
  const classes = useStyles();
  const { selectedYear } = useYear();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [
    incomeByTuitionData, setIncomeByTuitionData,
  ] = useState<IncomeByTuitionData>([{
    id: 'totals',
    label: '',
    values: {
      initialTuition: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsDiscounts: { amount: 0, variation: 0 },
      totalTuition: { amount: 0, variation: 0 },
      paidTuition: { amount: 0, variation: 0 },
      tuitionDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lad',
    label: 'LAD',
    values: {
      initialTuition: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsDiscounts: { amount: 0, variation: 0 },
      totalTuition: { amount: 0, variation: 0 },
      paidTuition: { amount: 0, variation: 0 },
      tuitionDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  }, {
    id: 'lod',
    label: 'LOD',
    values: {
      initialTuition: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsDiscounts: { amount: 0, variation: 0 },
      totalTuition: { amount: 0, variation: 0 },
      paidTuition: { amount: 0, variation: 0 },
      tuitionDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'em',
    label: 'EM',
    values: {
      initialTuition: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsDiscounts: { amount: 0, variation: 0 },
      totalTuition: { amount: 0, variation: 0 },
      paidTuition: { amount: 0, variation: 0 },
      tuitionDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  },
  {
    id: 'eme',
    label: 'EM - E',
    values: {
      initialTuition: { amount: 0, variation: 0 },
      specialDiscounts: { amount: 0, variation: 0 },
      agreementsDiscounts: { amount: 0, variation: 0 },
      totalTuition: { amount: 0, variation: 0 },
      paidTuition: { amount: 0, variation: 0 },
      tuitionDebt: { amount: 0, variation: 0 },
      debtPercentage: { amount: 0, variation: 0 },
    },
  }]);

  useEffect(() => {
    const fetchIncomeByTuitionData = async () => {
      try {
        const response = await getIncomeByTuitionData(selectedYear);
        setIncomeByTuitionData(response.incomeByTuitionData);
      } catch (err) {
        const e = err as AxiosError;
        enqueueSnackbar(e.response?.data.message || DEFAULT_API_ERROR_MESSAGE, {
          variant: 'error',
        });
      }
    };

    fetchIncomeByTuitionData();
  }, [selectedYear]);

  const handleGoBack = () => {
    history.push('/dashboard/financiero');
  };

  return (
    <Page title="Matrículas">
      <Box>
        <Box className={classes.backButtonContainer}>
          <IconButton
            onClick={handleGoBack}
            className={classes.backButton}
            size="small"
          >
            <ArrowBackIos className={classes.backIcon} />
          </IconButton>
          <Typography className={classes.pageTitle}>
            Matrículas
          </Typography>
        </Box>

        <Box className={classes.enrollmentsContainer}>
          <IndicatorsTable
            columns={[{
              id: 'initialTuition',
              label: 'Matrícula inicial',
            }, {
              id: 'specialDiscounts',
              label: 'Descuentos especiales',
            }, {
              id: 'agreementsDiscounts',
              label: 'Descuentos Convenios',
            }, {
              id: 'totalTuition',
              label: 'A pago matrícula',
              highlightBackground: true,
            }, {
              id: 'paidTuition',
              label: 'Matrícula pagada',
            }, {
              id: 'tuitionDebt',
              label: 'Matrícula pendiente',
            }, {
              id: 'debtPercentage',
              label: '% Deuda',
            }]}
            rows={incomeByTuitionData}
          />
        </Box>
      </Box>
    </Page>
  );
};

export default IncomeByTuition;
